module.exports = __webpack_public_path__ + "img/partner4.24672948.png";